"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _image = _interopRequireWildcard(require("../../tools/cloudinary/image"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Image = function Image(_ref) {
  var className = _ref.className,
      imageUrl = _ref.imageUrl,
      ratio = _ref.ratio,
      alt = _ref.alt,
      bgSize = _ref.bgSize,
      type = _ref.type,
      dataTestId = _ref.dataTestId;

  if (!imageUrl) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_indexModule.default.placeholder, _indexModule.default[ratio])
    }));
  }

  return /*#__PURE__*/_react.default.createElement("img", {
    className: className,
    "data-test-id": dataTestId,
    src: (0, _image.default)({
      src: imageUrl,
      ratio: ratio,
      numberofItems: 1,
      bgSize: bgSize,
      type: type
    }),
    alt: alt
  });
};

Image.defaultProps = {
  alt: ''
};
Image.propTypes = {
  className: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  ratio: _propTypes.default.oneOf(_image.ratioOptions),
  alt: _propTypes.default.string,
  bgSize: _propTypes.default.oneOf(['cover', 'contain']),
  type: _propTypes.default.oneOf(['mobile'])
};
var _default = Image;
exports.default = _default;